import React from 'react'
import { Media, Col, Row } from 'reactstrap'
import '../CSS/bootstrap.min.css'
import '../CSS/style.css'
import Banner from '../Img/Banner.png'
import SEE from '../Img/SEE.png'
import SEExtended from '../Img/SEExt.png'

const Header = (props) => (
    <header className="header-section" 
    style={{background: `url(${Banner}) center`, 
    backgroundSize:'cover', backgroundPosition: 'center-left'}}>
        <div className="site-logo">
            <Row>
            <Col style={{display:'block', "margin-top": "auto", "margin-bottom" : "auto"}}>
            <div style={{background:`url(${SEE}) center`, backgroundSize:'cover', height:'6em', width:'9em'}}> </div>
            </Col>
            <div class="d-none d-xl-block"  style={{display:'block', "margin-top": "auto", "margin-bottom" : "auto"}}>
            <div style={{background:`url(${SEExtended}) center`, backgroundSize:'cover', height:'5em', width:'50em'}}> </div>
            </div>
            </Row>
            {/*<h1>SEE</h1>*/}
            {/*Sistema de expediente estudiantil*/}
        </div>
    </header>
)
export default Header
